import dayjs from 'utils/dayjs';

const toDay = value => dayjs(value).startOf('day');

export const DateUtils = {
  isSameDay(dayA, dayB) {
    if (!dayA || !dayB) return false;
    return toDay(dayA).isSame(toDay(dayB));
  },

  isDayInRange(day, range = {}) {
    const { from, to } = range;
    if (!day || !from || !to) return false;
    return toDay(day).isBetween(toDay(from), toDay(to), null, '[]');
  },

  addDayToRange(day, range = {}) {
    const { from, to } = range;
    if (!from || to) {
      return { from: day, to: null };
    }
    if (toDay(day).isBefore(toDay(from))) {
      return { from: day, to: from };
    }
    return { from, to: day };
  },

  isPastDay(day) {
    return toDay(day).isBefore(dayjs().startOf('day'));
  },

  isFutureDay(day) {
    return toDay(day).isAfter(dayjs().startOf('day'));
  },
};

export default DateUtils;
